import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['input', 'row']

    connect() {}

    filter() {
        const query = this.inputTarget.value.toLowerCase()

        this.rowTargets.forEach((el) => {
            const name = el.dataset.name.toLowerCase()
            if(!name.includes(query)) {
                el.classList.add('hidden')
            } else {
                el.classList.remove('hidden')
            }
        })
    }
}
